import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';
import { catchError, retry, tap, map } from 'rxjs/operators';
import { LoadingController, AlertController, ModalController } from '@ionic/angular';
import { SaleMethods } from '../../constants/SaleMethods';
import { Router } from '@angular/router';
import { LocalStorageKeys } from '../../constants/LocalStorageKeys';
import { UiTextStatuses } from '../../constants/UiTextStatuses';
import { AppComponent } from '../app.component';
import { APIEnviroments } from '../../constants/APIEnviroments';
import { ProductionCompanyCodes } from '../../constants/ProductionCompanyCodes';
import { ItemTypes } from '../../constants/ItemTypes';


@Injectable()
export class DataAccessService {

    public static globalServerAddress = APIEnviroments.ShiftGodaddy;
    public static defaultCompanyCode = ProductionCompanyCodes.Dynamic;
    public static versionCode: string = '2.5.7';

    constructor(private http: HttpClient, private loadingController: LoadingController, private modalController: ModalController, private router: Router, private alertController: AlertController) {
        this.initHttpOptions();
    }

    public initHttpOptions() {
        var activeSaleMethod = localStorage.getItem(LocalStorageKeys.ActiveSaleMethod);
        var loginToken = localStorage.getItem(LocalStorageKeys.LoginToken);
        this.LanguageKey = localStorage.getItem(LocalStorageKeys.LanguageCode) || 'en';
        this.UserLoginId = Number(localStorage.getItem(LocalStorageKeys.UserLoginId));
        
        if (!activeSaleMethod) {
            //Default
            this.ActiveSaleMethod = SaleMethods.Retail;
        } else {
            this.ActiveSaleMethod = Number(activeSaleMethod);
        }

        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `bearer ${loginToken}`,
                'SaleMethod': `${this.ActiveSaleMethod}`,
                'AX-Version': DataAccessService.versionCode,
            })
        };
    }

    public static globalServerEndPoint = DataAccessService.globalServerAddress + 'api/';
    serverEndPoint = DataAccessService.globalServerEndPoint;

    httpOptions: any = null;

    public ActiveSaleMethod: SaleMethods;// = SaleMethods.Retail;
    public LanguageKey: string;
    public UserLoginId: number;
    DeviceToken: string = null;

    public getDeviceToken() {

        if (this.DeviceToken !== null)
            return this.DeviceToken;

        this.DeviceToken = localStorage.getItem(LocalStorageKeys.DeviceToken);

        if (this.DeviceToken === null) {
            this.DeviceToken = 'device-' + new Date().getTime();
            localStorage.setItem(LocalStorageKeys.DeviceToken, this.DeviceToken);
        }

        return this.DeviceToken;
    }

    //This can not be async because it's returning to catchError pipe
    handleError = (error: HttpErrorResponse) => {

        this.loadingController.dismiss();

        if (error.status === 401) {

            var component = this;
            var dismissModals = async function () {
                var modal = await component.modalController.getTop();

                if (modal) {
                    try {
                        await component.modalController.dismiss();
                    }
                    catch (e) {

                    }
                    dismissModals();
                }
            };

            try {
                this.alertController.dismiss();
            }
            catch(e){

            }

            dismissModals();

            localStorage.removeItem(LocalStorageKeys.LoginToken);

            AppComponent.completelyStopModalCheck = true;

            this.router.navigate(['login']);
            return;
        }

        var errorMessage = '';
        var errorTitle = '';

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            //console.error('An error occurred:', error.error.message);

            errorTitle = 'Sorry';
            errorMessage = 'An error occured.';

            //alert(JSON.stringify(error));
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            //console.error(
            //    `Backend returned code ${error.status}, ` +
            //    `body was: ${error.error}`);

            //alert(JSON.stringify(error));
            //this.alertController.create();

            errorTitle = 'Error';
            errorMessage = "Sorry, something went wrong on the server. This might be a connection issue. Or there could be a more serious issue.";

            console.error(error.error)
        }

        this.showErrorMessage(errorTitle, errorMessage);


        //If this is not returned. The success part of the subscribe wills till run. As if no error occured.
        return throwError(error);
    }

    public async showErrorMessage(title: string, message: string, okButtonText: string = 'Ok', additionalButtons = []) {
        const alert = await this.alertController.create({
            header: title,
            message: message,
            buttons: [
                ...additionalButtons,
                {
                    text: okButtonText,
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (x) => {

                    }
                }
            ]
        });

        await alert.present();
    }

    async showServerLoadingAsync() {
        const loading = await this.loadingController.create({
            spinner: "crescent",
            message: 'Please wait...',
            translucent: true,
            cssClass: 'loading-modal'
        });

        loading.present();
    }

    async dismissServerLoading() {
        this.loadingController.dismiss();
    }

    getJobScreenSelectableItems() {
        return this.http.get(`${this.serverEndPoint}services/get-selectable-items`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getServiceItems(ItemSubType, Ledger) {
        return this.http.get(`${this.serverEndPoint}services/get-items/${ItemSubType}/${Ledger}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getParts(ItemSubType, Ledger) {
        return this.http.get(`${this.serverEndPoint}stock/get-items/${ItemSubType}/${Ledger}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getPartItem(ItemID) {
        return this.http.get(`${this.serverEndPoint}stock/get-part-item/${ItemID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getJobDetails(ServiceJobID, data) {
        return this.http.post(`${this.serverEndPoint}services/get-job-details/${ServiceJobID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    keepTransactionLocked(TransactionID, deviceToken) {
        return this.http.get(`${this.serverEndPoint}system/keep-transaction-locked/${TransactionID}/${deviceToken}`, this.httpOptions);
    }

    vehicleCostingLock(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/vehicle-costing-lock`, data, this.httpOptions);
    }

    jobCardLock(data) {
        return this.http.post(`${this.serverEndPoint}services/lock`, data, this.httpOptions);
    }

    releaseTransactionLock(TransactionID) {
        return this.http.get(`${this.serverEndPoint}system/release-transaction-lock/${TransactionID}`, this.httpOptions)
            //.pipe(
            //    catchError(this.handleError)
            //);
    }

    releaseVehicleCostingLock(VehicleID) {
        return this.http.get(`${this.serverEndPoint}system/release-vehicle-costing-lock/${VehicleID}`, this.httpOptions)
            //.pipe(
            //    catchError(this.handleError)
            //);
    }

    createJob(data) {
        return this.http.post(`${this.serverEndPoint}services/create-job`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveJob(ServiceJobID, data) {
        return this.http.put(`${this.serverEndPoint}services/save-job/${ServiceJobID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    closeJob(data) {
        return this.http.post(`${this.serverEndPoint}services/close-job`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    vehicleVinCheck(vin) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-vehicle-by-vin/${vin}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getServiceHisotry(TransactionType: number, Status: number[], Ledger: number, PaymentStatus: boolean, ShowDeleted: boolean = false) {
        return this.http.get(`${this.serverEndPoint}services/get-service-history/${TransactionType}/${Status}/${Ledger}/${PaymentStatus}/${ShowDeleted}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleServiceHisotry(data) {
        return this.http.post(`${this.serverEndPoint}services/get-vehicle-service-history`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getUsers(UserType) {
        return this.http.get(`${this.serverEndPoint}users/get-users/${UserType}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    assignTechnician(ServiceJobID, ID) {
        return this.http.get(`${this.serverEndPoint}users/assign-technician/${ServiceJobID}/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    partNumberCheckUp(partNumberData) {
        return this.http.post(`${this.serverEndPoint}stock/part-number-checkup`, partNumberData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    savePart(data) {
        return this.http.post(`${this.serverEndPoint}stock/save-part`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    vinOCR(data) {

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/octet-stream',
                'Ocp-Apim-Subscription-Key': 'f6794e9dfa5e4bd7925786034b187d01'
            })
        };

        return this.http.post('https://westcentralus.api.cognitive.microsoft.com/vision/v2.0/ocr?language=unk&detectOrientation=true', data, httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    togglePaymentStatus(data) {
        return this.http.post(`${this.serverEndPoint}services/toggle-payment-status`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    removeTransaction(data) {
        return this.http.post(`${this.serverEndPoint}services/remove-transaction`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    markWIPAsLostSale(data) {
        return this.http.post(`${this.serverEndPoint}services/mark-as-lost-sale`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    creditTransaction(data) {
        return this.http.post(`${this.serverEndPoint}services/credit-transaction`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    findInStock(partNumberData) {
        return this.http.post(`${this.serverEndPoint}stock/find-in-stock`, partNumberData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    findByBarcode(barcodeData, formatFor) {
        return this.http.post(`${this.serverEndPoint}stock/find-by-barcode/${formatFor}`, barcodeData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveOrder(data) {
        return this.http.post(`${this.serverEndPoint}stock/save-order`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getOrderDetails(TransactionID, data) {
        return this.http.post(`${this.serverEndPoint}stock/get-order-details/${TransactionID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getOrders(Status, TransactionType) {
        return this.http.get(`${this.serverEndPoint}stock/get-orders/${Status}/${TransactionType}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    submitOrder(TransactionID, data) {
        return this.http.post(`${this.serverEndPoint}stock/submit-order/${TransactionID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    checkSSC(vin, log) {
        return this.http.post(`https://app.toyota.iq/ShiftApi/API.asmx/AutoExpertVinLookup`, {
            vin: vin,
            log: log
        })
            //.pipe(
            //    catchError(this.handleError)
            //);
    }

    sarii(data) {
        return this.http.post('https://app.toyota.iq/Extra/API.asmx/SaRII', data).pipe(
            catchError(this.handleError)
        );
    }

    checkExternalServiceHistory(vin) {
        return this.http.get(`https://app.toyota.iq/AfterSalesPortal/API.asmx/Leasing?customerNumber=""&vin="${vin}"`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        })
            .pipe(
                //catchError(this.handleError)
            );
    }

    uploadSignature(TransactionID, data) {
        return this.http.post(`${this.serverEndPoint}services/upload-signature/${TransactionID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getBackOrders() {
        return this.http.get(`${this.serverEndPoint}stock/get-back-orders`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getUnconfirmedReceivedParts() {
        return this.http.get(`${this.serverEndPoint}stock/get-unconfirmed-received-parts`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveUnconfirmedReceivedParts(ids) {
        return this.http.post(`${this.serverEndPoint}stock/save-unconfirmed-received-parts`, ids, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    clearBackOrders(ids) {
        return this.http.post(`${this.serverEndPoint}stock/clear-backorders`, ids, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    receiveBackOrders(ids) {
        return this.http.post(`${this.serverEndPoint}stock/receive-backorders`, ids, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }  

    downloadPurchaseTemplate() { 
        window.open("https://tiqappstorage.blob.core.windows.net/template-files/Template.xlsx", "_blank");
    } 

    getItemMovements(ItemID, Mode) {
        return this.http.get(`${this.serverEndPoint}/stock/get-item-movements/${ItemID}/${Mode}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportItemMovement(ItemID, Mode) { 
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}/stock/export-item-movements/${ItemID}/${Mode}`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveInvoice(ID, ledger, AccountID, body) {
        return this.http.post(`${this.serverEndPoint}stock/save-invoice/${ID}/${ledger}/${AccountID}`, body, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getInvoiceDetails(ID) {
        return this.http.get(`${this.serverEndPoint}stock/get-invoice-details/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccounts(AccountType) {
        return this.http.get(`${this.serverEndPoint}accounts/get-accounts/${AccountType}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccountHistory(ID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-account-history/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportAccountHistory(ID) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}accounts/export-account-history/${ID}`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccount(ID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-account-and-selectable-items/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    assignInvoiceCustomer(TransactionID, AccountID) {
        return this.http.get(`${this.serverEndPoint}stock/assign-account/${TransactionID}/${AccountID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveAccount(ID, AccountType, Model) {
        return this.http.post(`${this.serverEndPoint}accounts/save-account/${ID}/${AccountType}`, Model, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    removeAccount(ID) {
        return this.http.post(`${this.serverEndPoint}accounts/remove-account/${ID}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getTIQPartStock(Code) {
        return this.http.get(`${this.serverEndPoint}stock/get-tiq-part-stock/${Code}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    //getAllStatsBackground() {
    //    return this.http.get(`${this.serverEndPoint}system/get-all-stats`, this.httpOptions);
    //}

    //getAllStats() {
    //    return this.http.get(`${this.serverEndPoint}system/get-all-stats`, this.httpOptions).pipe(
    //        catchError(this.handleError)
    //    );
    //}

    saveExpense(TransactionID, items) {
        return this.http.put(`${this.serverEndPoint}accounts/save-expense/${TransactionID}`, items, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getExpenseDetails(TransactionID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-expense-details/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    approveExpense(TransactionID) {
        return this.http.get(`${this.serverEndPoint}accounts/approve-expense/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    markPayableAsPaid(TransactionID) {
        return this.http.get(`${this.serverEndPoint}accounts/mark-payable-as-paid/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccountPageTransactions(TransactionType) {
        return this.http.get(`${this.serverEndPoint}accounts/get-transactions/${TransactionType}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveUser(ID, Model) {
        return this.http.post(`${this.serverEndPoint}users/save-user/${ID}`, Model, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveCompany(ID, Body) {
        return this.http.post(`${this.serverEndPoint}system/save-company/${ID}`, Body, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveRole(ID, Model) {
        return this.http.post(`${this.serverEndPoint}users/save-role/${ID}`, Model, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getRoles() {
        return this.http.get(`${this.serverEndPoint}users/get-roles`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getUserFormSelectableItems() {
        return this.http.get(`${this.serverEndPoint}users/get-selectable-items`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getRoleDetails(ID) {
        return this.http.get(`${this.serverEndPoint}users/get-role-details/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getServerPermissionTree() {
        return this.http.get(`${this.serverEndPoint}users/get-permission-tree`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getUserDetails(ID) {
        return this.http.get(`${this.serverEndPoint}users/get-user-details/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getStandardTimes(code, vehicleId, Ledger) {
        return this.http.get(`${this.serverEndPoint}services/get-standard-times/${code}/${vehicleId}/${Ledger}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    invoicePartsSale(ID, medium) {
        return this.http.get(`${this.serverEndPoint}stock/invoice-parts-sale/${ID}/${medium}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveInvoicePayment(InvoiceID, Amount, PaymentID, USDToIQDRate) {
        return this.http.put(`${this.serverEndPoint}stock/save-invoice-payment/${InvoiceID}/${Amount}/${PaymentID}/${USDToIQDRate}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    confirmInvoicePayment(PaymentID) {
        return this.http.post(`${this.serverEndPoint}stock/confirm-invoice-payment/${PaymentID}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError),
            );
    }

    removeInvoicePayment(PaymentID) {
        return this.http.post(`${this.serverEndPoint}stock/remove-invoice-payment/${PaymentID}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError),
            );
    }

    getPayments(InvoiceID: number) {
        return this.http.get(`${this.serverEndPoint}stock/get-payments/${InvoiceID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getPaymentDetails(PaymentID: number) {
        return this.http.get(`${this.serverEndPoint}stock/get-payment-details/${PaymentID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleOrder(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-order`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getIMSLogin() {
        return this.http.get(`${this.serverEndPoint}vehicles/login-to-ims`, this.httpOptions);
    }

    getVehicleTransactions(TransactionType, Status, SaleMethod) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-transactions/${TransactionType}/${Status}/${SaleMethod}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleOrderDetails(TransactionID, GetOuterOrder, ForceIMSUpdate) {
        
        if (!GetOuterOrder) {
            return this.http.get(`${this.serverEndPoint}vehicles/get-order-details/${TransactionID}/${GetOuterOrder}/${ForceIMSUpdate}`, this.httpOptions).pipe(
                catchError(this.handleError)
            );
        }

        return this.http.get(`${this.serverEndPoint}vehicles/get-order-details/${TransactionID}/${GetOuterOrder}/${ForceIMSUpdate}`, this.httpOptions);
    }

    getVehicleSaleDetails(TransactionID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-sale-details/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    closeVehicleOrder(TransactionID) {
        return this.http.get(`${this.serverEndPoint}vehicles/close-order/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    rejectVehicleOrder(TransactionID) {
        return this.http.get(`${this.serverEndPoint}vehicles/reject-order/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleOrderSelectableItemsV2(SaleMethod, TIQRegion) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-selectable-items/${SaleMethod}/${TIQRegion}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    findInVehicleStock(vehicleVinData) {
        return this.http.post(`${this.serverEndPoint}vehicles/find-in-stock`, vehicleVinData, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleStockV2(data) {

        var options = this.httpOptions;
        if (data['Export'])
            options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}vehicles/get-stock`, data, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    getRegions(CityID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-regions/${CityID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveRegion(ID, Model) {
        return this.http.post(`${this.serverEndPoint}accounts/save-region/${ID}`, Model, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getCities() {
        return this.http.get(`${this.serverEndPoint}accounts/get-cities/`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getRegion(ID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-region/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleSale(TransactionID, data) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-sale/${TransactionID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    assignVehicleSaleCustomer(TransactionID, AccountID, SaleMethod) {
        return this.http.get(`${this.serverEndPoint}vehicles/assign-account/${TransactionID}/${AccountID}/${SaleMethod}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    assignVehicleForTransaction(TransactionType, ItemMovementID, data) {
        return this.http.post(`${this.serverEndPoint}vehicles/assign-vehicle-for-transaction/${TransactionType}/${ItemMovementID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehiclePricing(variantCode) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-pricing/${variantCode}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateVehiclePricing(variantCode, data) {
        return this.http.post(`${this.serverEndPoint}vehicles/update-pricing/${variantCode}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    closeVehicleSale(TransactionID, medium) {
        return this.http.get(`${this.serverEndPoint}vehicles/close-sale/${TransactionID}/${medium}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleCosts(ID, costTypesToInclude, costTypesToExclude) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-costs/${ID}/${costTypesToInclude}/${costTypesToExclude}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleCostTypes() {
        return this.http.get(`${this.serverEndPoint}vehicles/get-cost-types`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleCostDetails(ID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-vehicle-cost-details/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    confirmVehicleCost(ID) {
        return this.http.get(`${this.serverEndPoint}vehicles/confirm-vehicle-cost/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError),
            );
    }

    getAvaiableOptionsAccesorriesPackages(ID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-available-options-accessories-packages/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    scanVehicleForReceiving(VIN) {
        return this.http.get(`${this.serverEndPoint}vehicles/scan-vehicle-for-receiving/${VIN}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleTransfer(TransactionType, TransactionID, items) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-transfer/${TransactionType}/${TransactionID}`, items, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleTransferDetails(TransactionID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-transfer-details/${TransactionID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    confirmVehicleTransfer(ID) {
        return this.http.get(`${this.serverEndPoint}vehicles/confirm-transfer/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError),
            );
    }

    getVehicleDamageReports(ID, VehicleID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-damage-reports/${ID}/${VehicleID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleDamageConstants() {
        return this.http.get(`${this.serverEndPoint}vehicles/get-damage-constants`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleRecevingCosting(ID) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-vehicle-receiving-costs/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleRecevingCosting(ID, data) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-vehicle-receiving-costs/${ID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleDamage(ID, VehicleID, damagedAreas) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-vehicle-damage/${ID}/${VehicleID}`, damagedAreas, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getCompanies() {
        return this.http.get(`${this.serverEndPoint}system/get-companies/`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getActiveCompanyCode() {
        return this.http.get(`${this.serverEndPoint}system/get-active-company-code/`, this.httpOptions);
    }

    //testTlpRequest() {
    //    return this.http.post(`http://localhost:24995/ShiftApi/TLP.asmx/RedeemRequest`,
    //        {
    //            data: {
    //                "ItemID": 29,
    //                "DeviceGUID": "3873e042-c768-4316-9211-f45f96ae9d80",
    //                "phone": "07504812816",
    //                "pushNotificationToken": "fvGOv2Z2iwM:APA91bFYjoS5oRcAk3IW6w6Js5rBi1__Fzq_UYDIQYIe6kv-jtA_lYHMXoho5_aE0gid3xk0beeh-jywtmErYyXnbkaFO-jEH7P4N7Upjsm2asxIul37m9d0lQ0kLbcAfXbeov4Biy54",
    //                "lang": "en"
    //            }
    //        })
    //        .pipe(
    //            catchError(this.handleError)
    //        );
    //}

    getExpenseCategories() {
        return this.http.get(`${this.serverEndPoint}accounts/get-expense-categories`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    cameraSimulation() {
        return this.http.get(`${this.serverEndPoint}services/camera-simulation`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getBranches(hideCurrent: boolean = false) {
        return this.http.get(`${this.serverEndPoint}users/get-branches/${hideCurrent}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getLanguages() {
        return this.http.get(`${this.serverEndPoint}system/get-langauges`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    updateImpersonatedBranchID(ID) {
        return this.http.get(`${this.serverEndPoint}users/update-impersonated-branch-id/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    login(data) {
        return this.http.post(`${this.serverEndPoint}system/login`, data, this.httpOptions)
            .pipe(
                //catchError(this.handleError)
            );
    }

    getUiTexts(langKeys: string[], keys: string[], statuses: UiTextStatuses[]) {
        return this.http.post(`${this.serverEndPoint}system/get-ui-texts`, { LangKey: langKeys, Keys: keys, Statuses: statuses }, this.httpOptions);
    }

    getUiTextsAnonymous(langKeys: string[], keys: string[], statuses: UiTextStatuses[]) {
        return this.http.post(`${this.serverEndPoint}system/get-ui-texts`, { LangKey: langKeys, Keys: keys, Statuses: statuses }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'AX-Version': DataAccessService.versionCode,
            })
        });
    }

    insertUiTexts(data: any) {
        return this.http.post(`${this.serverEndPoint}system/insert-ui-texts`, data, this.httpOptions);
    }

    saveUiTextTranslation(data) {
        return this.http.post(`${this.serverEndPoint}system/save-ui-text-translation`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleCosting(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/get-vehicle-costing`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicleCosting(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/save-vehicle-costing`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getVehicleCostingServiceTransaction(vehicleId) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-vehicle-costing-service-transaction/${vehicleId}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    pushVehicleWIP(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/push-wip`, data, this.httpOptions);
    }

    insertNewVehicleCost(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/insert-new-vehicle-cost`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    removeVehicleCost(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/remove-vehicle-cost`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getMenuItems(data) {
        return this.http.post(`${this.serverEndPoint}services/get-menu-items`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    shareDocument(controller, transactionID, printoutGUID, data) {
        return this.http.post(`${this.serverEndPoint}services/share-document/${controller}/${transactionID}/${printoutGUID}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    generateShareableDocument(data:any) {
        return this.http.post(`${this.serverEndPoint}system/generate-shareable-document`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    markAsNoPendingChanges(component) {
        setTimeout(function () {
            component.unsavedChanges = false;
        }, 100);
    }

    getContactFormSelectableItems(AccountID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-contact-form-selectable-items/${AccountID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveAccountContact(data) {
        return this.http.post(`${this.serverEndPoint}accounts/save-account-contact`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getCardDetails(ID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-card-details/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getTasks(filters) {
        return this.http.post(`${this.serverEndPoint}accounts/get-tasks`, filters, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getContactHistory(data) {
        return this.http.post(`${this.serverEndPoint}accounts/get-contact-hisotry`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccountContact(data) {
        return this.http.post(`${this.serverEndPoint}accounts/get-account-contact`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getAccountVehicles(ID) {
        return this.http.get(`${this.serverEndPoint}accounts/get-account-vehicles/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportStockSalesReport() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}stock/export-sales-report`, {}, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportStockReport(body) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}stock/export-stock-report`, body, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    getSurveyDetails(data) {
        return this.http.post(`${this.serverEndPoint}accounts/get-survey-details`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getSurveyAnswers(data) {
        return this.http.post(`${this.serverEndPoint}accounts/get-survey-answers`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveVehicle(data) {
        return this.http.post(`${this.serverEndPoint}services/save-vehicle`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getJobServicePackages(ServiceJobID, Ledger, data) {
        return this.http.post(`${this.serverEndPoint}services/get-job-service-packages/${ServiceJobID}/${Ledger}`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportServiceHistory(TransactionType: number, Status: number[], Ledger: number, PaymentStatus: boolean, ShowDeleted: boolean = false) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}services/export-service-history/${TransactionType}/${Status}/${Ledger}/${PaymentStatus}/${ShowDeleted}`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportUnconfirmedReceivedParts() {
        
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}stock/export-unconfirmed-received-parts`, options)
            .pipe(
                catchError(this.handleError)
            );
}

    exportOrderRecords() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}stock/export-order-history`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportOrderDetailedRecords() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}stock/export-order-history-detailed`, options)
            .pipe(
                catchError(this.handleError)
            );
    }
     

    exportServiceHistoryLines(TransactionType: number, Status: number[], Ledger: number, PaymentStatus: boolean, ShowDeleted: boolean = false, ItemType: ItemTypes) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}services/export-service-history-lines/${TransactionType}/${Status}/${Ledger}/${PaymentStatus}/${ShowDeleted}/${ItemType}`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportVehicleSales() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}vehicles/export-vehicle-sales`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportVSKPI(body) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}vehicles/export-vs-kpi`, body, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportServicePackages() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}services/export-service-packages`, {}, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    linkUnlinkVehicleFromAccount(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/link-unlink-vehicle-from-account`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getPickingList() {
        return this.http.post(`${this.serverEndPoint}stock/get-picking-list`, {}, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getKPIs(date) {
        return this.http.post(`${this.serverEndPoint}vehicles/get-kpis/${date}`, {}, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getKPIsSilent(date) {
        return this.http.post(`${this.serverEndPoint}vehicles/get-kpis/${date}`, {}, this.httpOptions);
    }

    logKPI(type, count, date) {
        return this.http.post(`${this.serverEndPoint}vehicles/log-kpi/${type}/${count}/${date}`, {}, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getQBOAccountMappingData() {
        return this.http.get(`${this.serverEndPoint}accounting/get-account-mapping-data`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    saveQBOAccountMapping(data) {
        return this.http.post(`${this.serverEndPoint}accounting/save-account-mapping`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    removeUser(ID) {
        return this.http.post(`${this.serverEndPoint}users/remove-user/${ID}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    removeRole(ID) {
        return this.http.post(`${this.serverEndPoint}users/remove-role/${ID}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getTransactionHistory(ID) {
        return this.http.get(`${this.serverEndPoint}system/get-transaction-history/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getItemHistory(ID) {
        return this.http.get(`${this.serverEndPoint}stock/get-item-history/${ID}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    autoExpertQBOAuth() {
        return this.http.get(`${this.serverEndPoint}accounting/autoexpert-qbo-auth/`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    vsCreditNote(data) {
        return this.http.post(`${this.serverEndPoint}vehicles/credit-transaction`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportPickingList() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}stock/export-picking-list`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportMovements(data) {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.post(`${this.serverEndPoint}stock/export-movements`, data, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    exportBackorders() {
        var options = this.httpOptions;

        options = { ...this.httpOptions, responseType: 'blob' };

        return this.http.get(`${this.serverEndPoint}stock/export-backorders`, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    expandPartSupersession(data) {
        return this.http.post(`${this.serverEndPoint}stock/expand-part-supersession`, data, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    deleteVehiclePricing(variantCode) {
        return this.http.post(`${this.serverEndPoint}vehicles/delete-pricing/${variantCode}`, null, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    getTIQPricing(variantCode) {
        return this.http.get(`${this.serverEndPoint}vehicles/get-tiq-pricing/${variantCode}`, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }
}